import { useEffect, useState } from 'react';
import { getCoordinates } from '../../utils/location';
import * as logger from '../../logger';
import * as api from '../../api';

export const useBrowserCoordinates = (): api.Places.Geometry | undefined => {
  const [browserCoordinates, setBrowserCoordinates] = useState<
    api.Places.Geometry | undefined
  >(undefined);
  useEffect(() => {
    getCoordinates()
      .then((browserCoordinate) => {
        if (browserCoordinate) {
          setBrowserCoordinates(browserCoordinate);
        }
      })
      .catch((err) => {
        logger.error(err);
      });
  }, []);
  return browserCoordinates;
};
